import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@justgiving/react-tracking';
import styles from './SocialButtonsList.scss';
import { captureException } from '@sentry/browser';
import { useShareContext } from '../../context/ShareContext';

export type FacebookShareProps = {
  buttonText?: string;
  showPrefix?: boolean;
  className?: string;
  trackingData?: Record<string, any>;
  onClick?: () => void;
};

const FacebookShare: FunctionComponent<FacebookShareProps> = ({
  buttonText,
  trackingData,
  className,
  showPrefix,
  onClick = () => {},
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { shareItems } = useShareContext();

  const facebookText = () => {
    const prefix = showPrefix && (
      <>
        <span className={styles.facebookButtonText}>
          {t('common.shareOn', 'Share on ')}
        </span>
        Facebook
      </>
    );

    return prefix || 'Facebook';
  };

  const handleClick = () => {
    FB.ui(
      {
        method: 'share',
        href: shareItems.facebook.url,
      },
      response => {
        if (response && (response.error_message || response.error_code)) {
          captureException({
            facebookErrorCode: response.error_code,
            facebookErrorMessage: response.error_message,
          });
        }
      },
    );
    onClick();
  };

  return (
    <Button
      className={`jg-btn jg-btn--facebook ${styles.button} ${className || ''}`}
      onClick={handleClick}
      type="button"
      trackingData={{
        action_name: 'click',
        subtype: 'share',
        event: 'click',
        event_value: 'facebook',
        ...trackingData,
      }}
    >
      {buttonText || facebookText()}
    </Button>
  );
};

export default FacebookShare;
